import React from 'react';
import { NavLink } from 'react-router-dom';
import Premium from '../Assets/Images/Premium.jpg';
import Seal from '../Assets/Images/Seal.gif';

export default () => (
  <footer className="pt-4 my-md-5 pt-md-5 border-top">
    <div className="container">
      <div className="row">
        <div className="col-12 col-md">
          <div className="mb-3">
            <NavLink to="/" className="SroFilterLogo">
              <img
                src={Seal}
                alt="SRO Filter"
                style={{ background: `url('${Premium}')` }}
              />
              SROFILTER
            </NavLink>
          </div>

          <small className="d-block mb-3 text-muted">
            SRO Filter Gateway Security &copy; {new Date().getFullYear()} • All rights reserved.
          </small>
        </div>

        <div className="col-6 col-md">
          <h5>Shortcuts</h5>

          <ul className="list-unstyled text-small">
            <li>
              <NavLink className="text-muted" to="/Players">
                Player Database
              </NavLink>
            </li>
            <li className="mt-1">
              <NavLink className="text-muted" to="/Guilds">
                Guild Database
              </NavLink>
            </li>
            <li className="mt-1">
              <NavLink className="text-muted" to="/Logs">
                Live Server Logs
              </NavLink>
            </li>
            <li className="mt-1">
              <NavLink className="text-muted" to="/GodMode">
                Live Radar Map
              </NavLink>
            </li>
          </ul>
        </div>

        <div className="col-6 col-md">
          <h5>License & Billing</h5>

          <ul className="list-unstyled text-small">
            <li>
              <NavLink className="text-muted" to="/Payments">
                Live Payments Stream
              </NavLink>
            </li>
            <li className="mt-1">
              <NavLink className="text-muted" to="/ServerSettings">
                Server Configuration
              </NavLink>
            </li>
            <li className="mt-1">
              <NavLink className="text-muted" to="/PCIPLimit">
                PC/IP Limit Guard
              </NavLink>
            </li>
          </ul>
        </div>

        <div className="col-6 col-md">
          <h5>About & Contact</h5>

          <ul className="list-unstyled text-small">
            <li>
              <a
                className="text-muted"
                href="mailto:info@srofilter.com"
              >
                info@srofilter.com
              </a>
            </li>
            <li className="mt-1">
              <NavLink className="text-muted" to="/WebFAQ">
                FAQ & Support
              </NavLink>
            </li>
            <li className="mt-1">
              <NavLink className="text-muted" to="/WebNews">
                Patch Notes
              </NavLink>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </footer>
);
